import { Box, Table, TableHead, TableRow, TableCell, TableBody, Typography } from "@mui/material"
import { capitalize } from "lodash"
import type { FactorRuleDisplay, FactorRuleDisplayType, FactorRuleField } from "../types"
import FactorRuleRow from "./row"

export interface FactorRulesTableProps {
  rules: FactorRuleDisplay[]
  handleUpdateRule: (rule: FactorRuleDisplay, field: FactorRuleField, value: string | undefined, ruleDisplayType: FactorRuleDisplayType) => void
  handleRemoveRule: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
  ruleDisplayType: FactorRuleDisplayType
}

function getTableHeaders(ruleDisplayType: FactorRuleDisplayType) {
  return [
    { key: "factor", label: "Factor" },
    { key: "dataset", label: "Dataset" },
    { key: "current", label: <>Current<br />{capitalize(ruleDisplayType)}</> },
    { key: "min", label: "Min" },
    { key: "max", label: "Max" },
    { key: "actions", label: "" },
  ] as const
}

export function FactorRulesTable({ rules, handleUpdateRule, handleRemoveRule, ruleDisplayType }: FactorRulesTableProps) {
  const capitalizedRuleDisplayType = capitalize(ruleDisplayType)
  if (rules.length === 0) return null

  return <Box className="factor-rules-table-container">
    <Typography variant="subtitle2" className="factor-rules-table-title">
      {capitalizedRuleDisplayType}
    </Typography>
    <Table className="factor-rules-table" size="small">
      <TableHead className="table-head">
        <TableRow className="table-row">
          {getTableHeaders(ruleDisplayType).map((header) => (
            <TableCell className={`table-cell column-${header.key}`} key={header.key}>
              {header.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rules.map((rule, index) => (
          <FactorRuleRow
            key={rule.id}
            rule={rule}
            index={index}
            ruleDisplayType={ruleDisplayType}
            handleUpdateRule={handleUpdateRule}
            handleRemoveRule={handleRemoveRule}
          />
        ))}
      </TableBody>
    </Table>
  </Box>
}
